export const getModalsIdsArray = (n = 5) => {
  return Array.from({ length: n }, (_, i) => (i === 0 ? "dynamic-modal" : "dynamic-modal" + i));
};

// File helpers now live with the FilesHandler module; re-exported here for the
// existing consumers that still import them from utility/Utils.
export { isFileImage, loadFileIcon } from '@components/FilesHandler/helpers';

// Pure text/option helpers. They live here rather than in Services/Helpers/Actions
// because the pdf components import them, and Actions pulls in axios, sweetalert,
// toasts and localStorage — none of which can load inside the pdf worker.
// Actions re-exports them, so its existing consumers are unaffected.
export const titleCase = (str) => {
  // Convert the string to lowercase and split it into an array of words
  let words = str?.toLowerCase().split(" ") || [];

  // Iterate through each word
  for (let i = 0; i < words.length; i++) {
    // Capitalize the first letter of the word and concatenate it with the rest of the word
    words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
  }

  // Join the words back into a single string
  let titleCaseStr = words.join(" ");

  return titleCaseStr;
};

export const humanText = (text) => (text && text?.length ? titleCase(text?.replaceAll(/[^a-zA-Z0-9]+/g, ' ')) : '')

export const getDefaultOption = (option, data = [], valueKey = 'value') => {
  return data?.find(opt => opt?.[valueKey] === option)
};

// inlined rather than pulled from date-fns/moment: this module is bundled into the
// pdf worker, so it has to stay dependency-free.
const isToday = (date) => new Date().toDateString() === date.toDateString();

export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value);
  let formatting = { month: "short", day: "numeric" };

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: "numeric", minute: "numeric" };
  }

  return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value));
};
